import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mainApi } from '../../../../store/services/mainApi';
import { setItemsCart, revertCartUpdate } from '../../../../store/slices/allItemsCart';

const CartSynch = () => {
  const allItemsCart = useSelector((state) => state.allItemsCart.allItemsCart);
  const userData = useSelector((state) => state.accountData.userAcc);
  const userPhone = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData'))?.phone : null;

  // RTK Query Update Cart
  const [
    updateCartContact,
    { 
      isSuccess: isSuccessCart, 
      isError, 
      error 
    }
  ] = mainApi.useUpdateCurrentCartContactMutation();
  const dispatch = useDispatch();

  // Ref save old cart state
  const previousCartRef = useRef(null);

  // Effect load cart from server in Redux
  useEffect(() => {
    if (userPhone && userData.currentCart) {
      dispatch(setItemsCart(userData.currentCart));
    }
  }, [userData, userPhone, dispatch]);

  // Effect load cart to server
  useEffect(() => {
    if (userPhone) {
      // Save previous cart state before updating
      previousCartRef.current = allItemsCart;

      // Send a request to the server to update the cart
      updateCartContact({
        data: {
          phone: userPhone.replace('+', ''),
          currentCart: allItemsCart,
        },
        synck: true,
      });
    }
  }, [allItemsCart, userPhone, updateCartContact]);

  //Effect for catch errors: if server error, return previous state
  useEffect(() => {
    if (isError) {
      console.error('Error updating cart:', error);
      
      if (previousCartRef.current) {
        dispatch(revertCartUpdate(previousCartRef.current));
      }
    }
  }, [isError, error, dispatch]);
  
  return null;
}

export default CartSynch;